/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { LoopBannerProps } from '../lxs-anonymous-delivery.data';

const LoopBanner: React.FC<LoopBannerProps> = ({
    CLASS_NAME,
    resources,
    loopRegistrationLink,
    headingTag: Heading = 'h3',
    linkAriaLabel,
    linkTitle
}) => (
    <>
        <Heading className={`${CLASS_NAME}__loop-title`}>{resources.lxsAnonymousDeliveryLoopTitle}</Heading>
        <p className={`${CLASS_NAME}__loop-description`}>{resources.lxsAnonymousDeliveryLoopDescription}</p>
        <a
            className={`${CLASS_NAME}__link`}
            href={loopRegistrationLink?.linkUrl.destinationUrl}
            target={loopRegistrationLink?.openInNewTab ? '_blank' : undefined}
            rel={loopRegistrationLink?.openInNewTab ? 'noreferrer' : undefined}
            aria-label={linkAriaLabel}
            title={linkTitle}
        >
            {resources.lxsAnonymousDeliveryLoopLinkText}
        </a>
    </>
);

export default LoopBanner;
